import { Injectable } from '@angular/core';

import { EscalationType } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class EscalationTypesService extends GenericObjectsService<EscalationType> {
  protected override baseUrl = '/escalation-types';
}
